/*eslint-disable jsx-a11y/label-has-associated-control*/
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Title } from 'components_newui/Title/Title'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './View.Style'
import NxtCircularLoader from 'components/nxt_circular_loader/View'
import MultiSelectWithCheckbox from 'components_newui/multiSelect/View'
import { businessUnitTypes, marketTypes } from '../IdeaSubmit/IdeaDetails'
import investorsImg from 'img/imgs/investors.svg'
import ProfilePage from 'components_newui/profile/ProfilePage'
import { mapProfileResponse } from './BenchprofileMapper'


const UnifiedBenchProfile = (props) => {
  const {
    classes,
    benchUserDisplayProfileLoading,
    benchUserUpdateProfileLoading,
    benchUserUpdateProfileResponse,
    getBenchUserUpdateProfileFn,
    getBenchUserDisplayProfileFn,
    getInnovateUserIdeas,
    myEmail,
    benchUserDisplayProfileResponse,
    benchDropdownList,
    getBenchDropdownDatalistFn,
    InnovateUserIdeasList,
    onEditMyProfile,
    match
  } = props || {}

  const [isEditMode, setIsEditMode] = useState(false)

  useEffect(() => {
    getBenchDropdownDatalistFn()
  }, [getBenchDropdownDatalistFn])

  useEffect(() => {
    if (myEmail) {
      getBenchUserDisplayProfileFn(myEmail)
      getInnovateUserIdeas(myEmail)
    }
  }, [myEmail])

  const sanitizeObject = (obj) => {
    if (!obj || typeof obj !== 'object') return {}
    const cleaned = {}
    Object.entries(obj).forEach(([key, value]) => {
      cleaned[key] = value === 'null' || value === '' ? null : value
    })
    return cleaned
  }

  const profileData = sanitizeObject(benchUserDisplayProfileResponse)

  const handleEditClick = () => setIsEditMode(true)
  const handleCancelEdit = () => setIsEditMode(false)

  const handleUpdateSuccess = () => {
    setIsEditMode(false)
    if (myEmail) {
      getBenchUserDisplayProfileFn(myEmail)
    }
  }

  const { params, path } = match;
  // 1. Check if the user is looking at their own profile
  const isMe = path.toLowerCase().endsWith('/me') || params.email === myEmail;
  // 2. Fallback to myEmail if it is me, otherwise use the route param email
  const userEmail = isMe ? myEmail : params.email;
  // 3. Enable editing only if the target email belongs to the logged-in user
  const isEnableEditProfileButton = userEmail === myEmail;
  
  const ProfileResult = mapProfileResponse(profileData);


  return (
    <NxtCircularLoader isLoading={benchUserDisplayProfileLoading}>



      

        {isEditMode ? (
          <EditProfileSection
            classes={classes}
            benchUserUpdateProfileLoading={benchUserUpdateProfileLoading}
            benchUserDisplayProfileLoading={benchUserDisplayProfileLoading}
            getBenchUserUpdateProfileFn={getBenchUserUpdateProfileFn}
            benchDropdownList={benchDropdownList}
            benchUserDisplayProfileResponse={profileData}
            myEmail={myEmail}
            onCancel={handleCancelEdit}
            onSuccess={handleUpdateSuccess}
          />
        ) : (
          // <DisplayProfileSection
          //   classes={classes}
          //   benchUserDisplayProfileResponse={profileData}
          //   InnovateUserIdeasList={InnovateUserIdeasList}
          // />

          <ProfilePage
            isEnableEditProfileButton={isEnableEditProfileButton}
            onEditProfile={handleEditClick}
            onEditMyProfile={onEditMyProfile}
            InnovateUserIdeasList={InnovateUserIdeasList}
            classes={classes}
            benchProfileResponse={ProfileResult}
            userProfileData={profileData}
          />
          
        )}
      {/* </div> */}
    </NxtCircularLoader>
  )
}


/* ===================== DISPLAY MODE ===================== */

const DisplayProfileSection = ({ classes, benchUserDisplayProfileResponse,InnovateUserIdeasList }) => {
  const {
    photo, name, alias, market, company, division, jobTitle, countryId,
    roles, skills, shortInfo, availabilityInTeam, badges = [],
  } = benchUserDisplayProfileResponse || {}

  return (
    <>
      {/* User Avatar & Basic Info */}
      <div className={classes.userAvatar}>
        <div className='imgProfile'>
          <img src={photo || investorsImg} alt='avatar' />
        </div>
        <div className='userContent'>
          <p><span>Name:</span> {name}</p>
          <p><span>Email:</span> {alias}</p>
          <p><span>Market:</span> {market}</p>
        </div>
      </div>

      {/* Detailed Info */}
      <div className={classes.joinIdeaTeamContent}>
        <div className='block'>
          <h3>Job Title:</h3>
          <p>{jobTitle || 'Not specified'}</p>
        </div>
        {/* <div className='block'>
          <h3>Company:</h3>
          <p>{company || 'Not specified'}</p>
        </div> */}
        <div className='block'>
          <h3>Country:</h3>
          <p>{countryId || 'Not specified'}</p>
        </div>
        <div className='block'>
          <h3>Division:</h3>
          <p>{division || 'Not specified'}</p>
        </div>

        <h2>My Availability to Join an Idea Team</h2>

        <div className='block'>
          <h3>Available to be recruited:</h3>
          <p>{availabilityInTeam ? 'Yes' : 'No'}</p>
        </div>
        <div className='block'>
          <h3>Ideal team role to fill:</h3>
          <p>{roles || 'Not specified'}</p>
        </div>
        <div className='block'>
          <h3>Skills in order of strength:</h3>
          <p>{skills || 'Not specified'}</p>
        </div>
        <div className='block'>
          <h3>Bio:</h3>
          <p>{shortInfo || 'Not specified'}</p>
        </div>
      </div>

    
      
      {/* Badges */}
      {/* {badges?.length > 0 && (
        <div className={classes.badgesItem}>
          <h2>Badges for {name}</h2>
          <div className='alignbadges'>
            {badges.map((item, index) => (
              <div className='badgesItem' key={item.name || index}>
                <img src={item.imgSrc || investorsImg} alt={item.name} title={item.name} />
                <h3>{item.name}</h3>
              </div>
            ))}
          </div>
        </div>
      )} */}
    </>
  )
}


/* ===================== EDIT MODE ===================== */

const EditProfileSection = ({
  classes, benchUserUpdateProfileLoading, benchUserDisplayProfileLoading,
  getBenchUserUpdateProfileFn, benchDropdownList, benchUserDisplayProfileResponse,
  myEmail, onCancel, onSuccess,
}) => {
  const { register, handleSubmit, setValue } = useForm()
  const {
    name = '', alias = '', company = '', division = '', jobTitle = '',
    market = '', availabilityInTeam = false, skills = 'ALL', roles = 'ALL', shortInfo = '',
  } = benchUserDisplayProfileResponse || {}

  const setDefaultValues = () => {
    setValue('Name', name)
    setValue('Email', alias)
    setValue('company', company)
    setValue('yourMarket', market)
    setValue('yourDivision', division)
    setValue('yourjobTitle', jobTitle)
    setValue('jointeam', availabilityInTeam)
    setValue('roles', roles)
    setValue('skills', skills)
    setValue('textbox', shortInfo)
  }

  useEffect(() => {
    setDefaultValues()
  }, [name, alias, company, division, jobTitle, market, availabilityInTeam, skills, roles])

  const handleSubmitForm = (datavalue) => {
    getBenchUserUpdateProfileFn(myEmail, datavalue, onSuccess)
  }

  const rolesArray = benchDropdownList.map(item => item.roles)
  const validRolesArray = [...new Set(rolesArray.filter(value => value !== undefined && value !== null && value !== ''))]
    ?.map((option) => ({ value: option, label: option }))
  const SkillsArray = benchDropdownList.map(item => item.skills)
  const validSkillsArray = [...new Set(SkillsArray.filter(value => value !== undefined && value !== null && value !== ''))]
    ?.map((option) => ({ value: option, label: option }))

  const initialRoles = roles?.length > 0 ? roles.split(',').map(role => ({ value: role, label: role })) : []
  const initialSkills = skills?.length > 0 ? skills.split(',').map(skill => ({ value: skill, label: skill })) : []

  return (
    <NxtCircularLoader isLoading={benchUserUpdateProfileLoading}>
      <div className={classes.BenchProfileWrp}>
        <form className='benchProfileFromWrp' onSubmit={handleSubmit(handleSubmitForm)}>
          <Title title='Edit Profile' />
          <div className='fieldbox fieldDisable'>
            <label htmlFor='Name'>Name</label>
            <input id='Name' type="text" name="Name" placeholder="Name" {...register('Name')} disabled />
          </div>
          <div className='fieldbox fieldDisable'>
            <label htmlFor="Email">Email</label>
            <input type="email" id="Email" name="Email" placeholder="e.g abc@abc.com" {...register('Email')} disabled />
          </div>
          {/* <div className='fieldbox'>
            <label htmlFor="company">Company</label>
            <input type="text" id="company" name="company" placeholder="e.g Vodacom" {...register('company')} />
          </div> */}
          <div className='fieldbox'>
            <div className={classes.fieldsetBox}>
              <label htmlFor='yourMarket'>Select Your Market</label>
              <select name="yourMarket" id="yourMarket" {...register('yourMarket')}>
                <option value="">Select...</option>
                {marketTypes.map(type => (
                  <option key={type.id} value={type.id}>{type.MarketName}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='fieldbox'>
            <div className={classes.fieldsetBox}>
              <label htmlFor='yourDivision'>Select Business Unit</label>
              <select name="yourDivision" id="yourDivision" {...register('yourDivision')}>
                <option value="">Select...</option>
                {businessUnitTypes.map(type => (
                  <option key={type.DivisionName} value={type.id}>{type.DivisionName}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='fieldbox'>
            <label htmlFor="yourjobTitle">Job Title</label>
            <input type="text" id="yourjobTitle" name="yourjobTitle" placeholder="e.g Soft engg." {...register('yourjobTitle')} />
          </div>

          <div className='subheading'>
            <h2>My Availability to Join an Idea Team</h2>
          </div>

          <div className='fieldbox checkboxInline'>
            <input type="checkbox" id="jointeam" name="jointeam" {...register('jointeam')} />
            <label htmlFor="jointeam">Are you available to join a team?</label>
          </div>

          <div className='fieldbox'>
            <label htmlFor='roles'>Roles</label>
            <MultiSelectWithCheckbox
              options={validRolesArray}
              register={register}
              name="roles"
              setValue={setValue}
              initialValue={initialRoles}
            />
          </div>

          <div className='fieldbox'>
            <label htmlFor='skills'>Skills</label>
            <MultiSelectWithCheckbox
              options={validSkillsArray}
              register={register}
              name="skills"
              setValue={setValue}
              initialValue={initialSkills}
            />
          </div>

          <div className='fieldbox'>
            <label htmlFor='desc'>Provide a short description of your experience, skills and accomplishments:</label>
            <textarea id='desc' {...register('textbox')} />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1.5rem' }}>
            <button type="button" className={classes.cancelButton} onClick={onCancel}>Cancel</button>
            <button type="submit" className={classes.cancelButton}>Update Profile</button>
          </div>
        </form>
      </div>
    </NxtCircularLoader>
  )
}


export default withStyles(styles)(UnifiedBenchProfile)

